import { HttpHeaders } from '@angular/common/http';


export let HttpOptions = {
  headers: new HttpHeaders({
    'Content-Type': 'application/json'
  })
};


export class ConstantsUrl {
  // public static BASE_URL: string = 'https://uatcredentiaopenapi.examroom.ai/api/';
  public static BASE_URL: string = "https://testapi.examroom.ai/api/";
  // public static BASE_URL: string = "https://preprodapi.examroom.ai/api/";
  // public static BASE_URL: string = "https://examroomapi.com/api/";
  // public static BASE_URL: string = "https://gse.examroom.ai/api/";
  public static BASE_URL_2: string = "https://webapi.examroom.ai/api/";

  public static SINGLE_SIGN: string = "SingleSignIn";
  public static LOGIN_VERIFICATION: string = "LoginVerification";
  public static CandidateLogout: string = "CandidateLogout";

  public static FORGOT_PASSWORD: string = "SingleSignInFrgtPwd";
  public static VERIFY_PASSCODE: string = "CandidateVerifyEPasscode";
  public static UPDATE_PASSWORD: string = "CandidateUpdatePwd";

  // public static  GET_IP: string ="http://api.ipstack.com/check?access_key=f822a536d4625cd0c93b018085cf0226&format=1";
  // public static GET_IP: string = "https://api.ipstack.com/check?access_key=2ffca7c340c689c0e47ba1d3988808d9";
  public static GENERATE_TOKEN: string = "Test/Test";
  public static EMAIL_TOKEN_VERIFY: string = "CandidateEmailTokenVerify";
  public static ExamRecordsUpdateCart: string = "ExamRecordsUpdateCart";
  public static CANDIDATE_VERIFICATION_CHECK: string = "CandidateVerificationCheck";
  public static SSO: string = "ScheduleStartExam";


}
